import { render, staticRenderFns } from "./ConsultaAvalPage.vue?vue&type=template&id=f893843a"
import script from "./ConsultaAvalPage.js?vue&type=script&lang=js&external"
export * from "./ConsultaAvalPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports